<template>
    <div>
      <div v-if="listType==='major'">
        <div class="t_header">{{courseItem.albumTitle+'('+courseItem.classCode+')'}}</div>
        <el-button @click="handleExport" type="primary" size="small" class="t_button">导出结果</el-button>
        <ClassItemListTable type="major" :tableData="tableData"></ClassItemListTable>
        <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="handleClick"/>
      </div>
    </div>
</template>

<script>
import ClassItemListTable from "./ClassItemListTable.vue";
import pagination from "./Pagination/index.vue";
import {
    getBatchList,
} from "@/api/TeachingStatistics";
export default {
    props:{
      courseItem: {type:Object,default:()=>{return {}}},
      listType: {type:String,default:''},
      isShows:{type:Boolean,default:false}
    },
    components: {
        ClassItemListTable,
        pagination
    },
    data() {
        return {
            activeName: "major",
            tableData: [],
            totalCount: {},
            total: 0,
            queryParams:{pageSize:10,pageNum:1},
            tableName:'',
            isShow:true
        };
    },
    methods: {
        // 标签页切换
        async handleClick() {
          if (this.listType === "major") {
            const {data} = await getBatchList({...this.queryParams,batch:this.courseItem.classCode});
            if(data.code === 100000){
              this.tableData = data.data.list;
              this.total = data.data.total;
            }
          }
        },
        /** 搜索/重置事件 */
        async handleSearch(params){
          if (this.listType === "major") {
              const {data} = await getBatchList(params);
              if(data.code === 100000){
                this.tableData = data.data.list;
              }
            }
        },
        /** 导出结果事件 */
        handleExport(){

        }
    },
    mounted() {
        this.handleClick();
    },
    watch:{
      isShows:function(val){
        if(!val){
          this.handleClick();
        }
      }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
    background-color: #64b0ff;
    span {
        color: #fff;
        .num {
            font-size: 24px;
            font-weight: 700;
            color: red;
        }
        .num:hover {
            color: #409eff;
        }
    }
}
::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    background-color: #d7d7d7;
    border: 0;
    span {
        color: #000;
        .num {
            color: red;
        }
    }
}
::v-deep .el-tabs--border-card > .el-tabs__content {
    padding: 0;
}
::v-deep .el-tabs--border-card > .el-tabs__header {
    height: 70px;
    padding-top: 30px;
    margin-top: 3px;
}
.t_header{
  background-color: #64b0ff;
  height: 58px;
  // margin: 0 auto;
  text-align: center;
  line-height: 58px;
  color: white;
  margin-top: 2px;
}
.t_button{
  margin: 20px 0px 0px 20px;
}
</style>